module.exports = __webpack_public_path__ + "static/img/14001004.03212d17.png";